<template>
  <div class="box">
    <template>
      <div v-if="Object.keys(GetCustomerDetail).length > 0" class="title_box">
        <div class="title_img_box">
          <img class="laba_img" :src="$OSSBaseUrl + 'laba.png'" />
        </div>
        <div class="title_text_box">
          Hi&nbsp;{{
            GetCustomerDetail.visitor_nick.substring(0, 5)
          }}，您共有<span class="title_text"
            >{{ GetCustomerDetail["total"] }}个</span
          >客户的旺旺咨询消息未处理！
        </div>
      </div>
      <MerchantsDay20210312 />
      <div v-for="(item, index) in Detail" :key="index" class="info_box">
        <div class="item_box">
          <div class="item_title_box">
            <div class="item_title_img_box">
              <img v-if="item.customer_grade"
                class="item_title_img"
                :src="level[item.customer_grade]['title_img']"
              />
            </div>
            <div class="item_title_text_box">
              <div class="item_title_text_top">
                <div class="item_title_name_box">
                  <span class="item_title_name">{{ item.buyer_nick }}</span>
                  <span class="item_title_tips">（客户昵称）</span>
                </div>
                <div ref="copy_customer" class="copy_button">复制</div>
              </div>
              <div v-if="item.customer_grade" class="item_title_text_bottom">
                {{ level[item.customer_grade]["text"]
                }}<span class="item_title_text_number">{{
                  level[item.customer_grade]["money"]
                }}</span>
              </div>
            </div>
          </div>




          <div class="problem_label_box">
            <div class="problem_label_item">
              <div class="problem_label_left">他正在询问</div>
              <div class="problem_label_right">
                <div
                  v-for="(msg_item, msg_index) in item.msg_sign"
                  :key="msg_index"
                  class="problem_label_right_item"
                >
                  {{ msg_item }}
                </div>
              </div>
            </div>
            <div class="problem_label_item problem_label_item02">
              <div class="problem_label_left">
                <div style="color: rgb(240, 245, 255)">一</div>
                <div>接待账号</div>
              </div>
              <div class="problem_label_right">
                <div
                  
                  class="problem_label_right_item"
                >
                  {{item.msg_receiver}}
                </div>
              </div>
            </div>
          </div>




          <div class="purchase_info_box">
            <div class="info_title">本店采购信息</div>
            <div v-if="item.pice.text" class="info_content_box">
              <div class="info_name">
                <span class="info_name_text">店铺客单价</span>：
              </div>
              <div class="info_content">
                <div class="info_content_item">
                  <!-- 后台传的客单价 -->
                  {{ item["pice"]["text"] }}
                </div>
              </div>
            </div>
            <div class="info_content_box">
              <div class="info_name">
                <span class="info_name_text">客&nbsp;户&nbsp;类&nbsp;型</span>：
              </div>
              <div class="info_content">
                <div
                  v-for="(type_item, type_index) in item.customer_type"
                  :key="type_index"
                  class="info_content_item"
                >
                  {{ type[type_item] }}
                </div>
              </div>
            </div>
          </div>
          <div class="button_box" v-if="is_sub == 0 || !is_sub">
            <div
              v-if="UserInfo.is_boss == 1"
              @click="
                refuseReceiver({
                  msg_id: item.msg_id,
                  buyer_nick: item.buyer_nick,
                  is_refuse: item.is_refuse,
                  buyer_openuid: item.buyer_openuid
                })
              "
              :class="[item.is_refuse ? 'no_btn' : '']"
              class="btn1"
            >
              {{ item.is_refuse ? "已拒绝接收" : "拒绝接收" }}
            </div>
            <div
              @click="
                jump_AddRecipient({
                  msg_id: item.msg_id,
                  buyer_nick: item.buyer_nick,
                  forwarded: item.forwarded,
                  buyer_openuid: item.buyer_openuid
                })
              "
              :class="[item.forwarded ? 'no_btn' : '']"
              class="btn1"
            >
              {{ item.forwarded ? "已转发" : "转给他人" }}
            </div>
            <div
              @click="
                jump_deal({
                  msg_id: item.msg_id,
                  buyer_nick: item.buyer_nick,
                  is_has_deal: item.is_has_deal,
                  buyer_openuid: item.buyer_openuid
                })
              "
              :class="[item.is_has_deal ? 'no_btn' : '']"
              class="btn1"
            >
              {{ item.is_has_deal ? "已处理" : "马上处理" }}
            </div>
            <div @click="jump_ww(item.buyer_nick,item.buyer_openuid)" class="btn">
              <i class="iconfont icon-wangwang1"></i>
              立即回复
            </div>
          </div>

          <div class="button_box"  v-if="is_sub == 1">
            <div
              @click="
                jump_deal({
                  msg_id: item.msg_id,
                  buyer_nick: item.buyer_nick,
                  is_has_deal: item.is_has_deal,
                  buyer_openuid: item.buyer_openuid
                })
              "
              :class="[item.is_has_deal ? 'no_btn' : '']"
              class="btn1"
            >
              {{ item.is_has_deal ? "已处理" : "马上处理" }}
            </div>
            <div @click="jump_ww(item.buyer_nick,item.buyer_openuid)" class="btn">
              <i class="iconfont icon-wangwang1"></i>
              立即回复
            </div>
          </div>
        </div>
        <!-- 免费试用次数提醒 UserInfo.is_free==1 1是免费版 -->
        <div v-if="GetCustomerDetail['surplus_free_num'] && GetCustomerDetail['surplus_free_num'] != 'paid'" class="FreeTrialTipsBox">
          <span>免费试用已使用{{ GetCustomerDetail["clicks_yx"] }}/3次，升级后次数无限</span>
          <div @click="FreeTrialTipsButton" class="FreeTrialTipsButton">立即升级</div>
        </div>
      </div>
    </template>
    <div v-show="confir_box">
      <Popup>
        <template>
          <div class="confir_box">
            <div class="confir_icon_box">
              <img
                :src="$OSSBaseUrl + 'confir_small_bell.png'"
                class="confir_icon"
              />
            </div>
            <div class="confir_title">
              拒绝后该买家消息将不再推送给您<br />
              您确定拒绝吗?
            </div>
            <div class="confir_btn_box">
              <div @click="confir_false" class="confir_btn btn_false">
                我再想想
              </div>
              <div @click="confir_true" class="confir_btn btn_true">确定</div>
            </div>
          </div>
        </template>
      </Popup>
    </div>
  </div>
</template>
<script>
import Clipboard from "clipboard";
import Popup from "@/components/Popup";
import MerchantsDay20210312 from "@/components/MerchantsDay20210312";
import { URL5,URL6 } from "@/utils/Redirect";
import { mapState } from "vuex";
import { Toast, Dialog, NoticeBar } from "vant";

export default {
  name: "CustomerInfo",
  components: {
    Popup,
    NoticeBar,
    MerchantsDay20210312,
  },
  data() {
    return {
      leida_1688: true, //是否1688有数据 测试
      confir_box: false,
      loading_data: false, //懒加载时防止重复触发
      type: {
        // 标识与后端对齐
        A1: "0成交新客户",
        A2: "成交1次新客户",
        A3: "成交2次以上老客户",
        A4: "成交11次以上忠诚客户",
        A5: "超期未购客户",
      },
      level: {
        // 标识与后端对齐
        B3: {
          tag: "[高级]",
          text: "1688采购实力：近30天采购",
          money: "50000+",
          title_img: this.$OSSBaseUrl + "head_portrait_B3.png",
        },
        B2: {
          tag: "[中级]",
          text: "1688采购实力：近30天采购",
          money: "10000+",
          title_img: this.$OSSBaseUrl + "head_portrait_B2.png",
        },
        B1: {
          tag: "[初级]",
          text: "1688采购实力：近30天采购",
          money: "2000+",
          title_img: this.$OSSBaseUrl + "head_portrait_B1.png",
        },
      },
      pice: {
        // 标识与后端对齐
        C3: { tag: "[高]", text: " 客单价3000元以上", money: "3000元以上" },
        C2: {
          tag: "[中]",
          text: " 客单价1000元-3000元",
          money: "1000元-3000元",
        },
        C1: { tag: "[低]", text: " 客单价小于1000元", money: "小于1000元" },
      },
      pice_index: ["intermediate"],
      msg_id: null,
      buyer_nick: null,
      buyer_openuid:null,
      page: 0, //懒加载当前页数
      parame: {
        page: 1,
        pagesize: 10,
      },
    };
  },
  computed: {
    ...mapState({
      GetCustomerDetail: (state) => {
        return state.CustomerInfo.GetCustomerDetail;
      },
      Detail: (state) => {
        return state.CustomerInfo.Detail;
      },
      UserInfo: (state) => {
        return state.Public.UserInfo;
      },
    }),
  },
  watch: {
    Detail: {
      handler: function (val, oldVal) {
        this.$nextTick(() => {
          let copy_customer = this.$refs.copy_customer;
          if (copy_customer) {
            let clipboard_customer = [];
            copy_customer.map((m, index) => {
              clipboard_customer[index] = new Clipboard(m, {
                text: () => {
                  return this.Detail[index].buyer_visitor_nick;
                },
              });
              clipboard_customer[index].on("success", function (e) {
                Toast("客户旺旺已复制");
              });
              clipboard_customer[index].on("error", function (e) {
                Toast("复制客户旺旺失败");
              });
            });
          }
        });
      },
      deep: true,
    },
  },
  created() {
    this.$store.commit("CustomerInfo/INIT_Detail", {});
    this.$store
      .dispatch("CustomerInfo/GetCustomerDetail", this.parame)
      .then((res) => {
        if (res.code == 1000) {
          this.parame.page += 1;
        } else {
          Toast(res.message);
        }
      });
  },
  mounted() {
    // console.log(this.UserInfo)
    this.is_sub = sessionStorage.getItem('is_sub')
    console.log(sessionStorage.getItem('is_sub'))
    this.$nextTick(function () {
      window.addEventListener("scroll", this.onScroll);
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    // 免费提示立即升级按钮
    FreeTrialTipsButton(){
      let Link = URL6 // 入端版banner跳转
      if(this.GetCustomerDetail.banner_url == 1 ){
        Link = URL5 // 千牛版banner跳转
      }
      let data = {
        page_from: "main_page",
        page_name: this.$route.name,
        page_time: "0.00",
        btn_name: "立即升级",
        receiver_id: "",
      };
      this.$store.dispatch("Public/inH5Record", data).then(res=>{
        window.location.href= Link
      });
    },
    // 跳转到阿里旺旺聊天
    jump_ww(targetId,buyerOpenuid) {
      let clicks_yx = this.GetCustomerDetail['clicks_yx']
      if( clicks_yx == 3 && this.GetCustomerDetail['surplus_free_num'] != 'paid' ){
        let text = `免费版已使用${clicks_yx}/3次，升级后次数无限制`;
        Toast(text);
        return false;
      }
      let data = {
        page_from: "main_page",
        page_name: "CustomerInfo",
        page_time: "0.00",
        receiver_id: "",
        btn_name: "立即回复",
        page_param: { targetId },
      };
      let AddClicks = this.$store.dispatch("CustomerInfo/AddClicks")
      let inH5Record = this.$store.dispatch("Public/inH5Record", data)
      let nick=this.$store.dispatch("Public/getBuyerNick",{buyer_openuid:buyerOpenuid})
      Promise.all([AddClicks,inH5Record,nick]).then(res=>{
        window.location.href = encodeURI("https://air.1688.com/app/mobile-group/chat-universal-page/pages/index/index.html?targetId=" + res[2].data.ww_nick);
      });
    },
    // 马上处理事件
    jump_deal(params) {
      if (params.is_has_deal) {
        return false;
      }
      this.$store
        .dispatch("CustomerInfo/DealNow", { buyer_nick: params.buyer_nick,buyer_openuid: params.buyer_openuid })
        .then((res) => {
          if (res.code == 1000) {
            this.$store.commit("CustomerInfo/NOCLICK_IS_DEAL", params.msg_id);
          } else {
            Toast(res.message);
          }
        });
    },

    // 跳转 AddRecipient 页
    jump_AddRecipient(params) {
      // 转发过一次不让转发
      if (params.forwarded != 0) {
        return false;
      }
      // 转发前保存属性 用于确认转发参数
      let data = {
        msg_id: params.msg_id,
        buyer_nick: params.buyer_nick,
        buyer_openuid:params.buyer_openuid
      };
      this.$store.commit("Public/SET_DATA", {
        key: "CustomerInfo",
        data: data,
      });
      this.$router.push("AddRecipient");
    },

    confir_true() {
      // 确认拒收消息
      this.$store
        .dispatch("CustomerInfo/RefuseReceiver", {
          msg_id: this.msg_id,
          buyer_nick: this.buyer_nick,
          buyer_openuid: this.buyer_openuid
        })
        .then((res) => {
          if (res.code == 1000) {
            Toast("您已拒绝该客户消息");
            this.$store.commit("CustomerInfo/NOCLICK_IS_REFUSE", this.msg_id); // 同步拒收状态
          } else {
            Toast(res.message);
          }
        });
      this.confir_box = false;
    },

    confir_false() {
      // 取消
      this.confir_box = false;
    },

    // 拒接此人消息
    refuseReceiver(params) {
      // msg_id, buyer_nick, is_refuse
      if (params.is_refuse == 0) {
        // 展示确认弹窗
        this.msg_id = params.msg_id;
        this.buyer_nick = params.buyer_nick;
        this.buyer_openuid = params.buyer_openuid;
        this.confir_box = true;
      } else {
        return false;
      }
    },

    // 获取滚动条当前的位置
    getScrollTop() {
      var scrollTop = 0;
      if (document.documentElement && document.documentElement.scrollTop) {
        scrollTop = document.documentElement.scrollTop;
      } else if (document.body) {
        scrollTop = document.body.scrollTop;
      }
      return scrollTop;
    },
    // 获取当前可视范围的高度
    getClientHeight() {
      var clientHeight = 0;
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight = Math.min(
          document.body.clientHeight,
          document.documentElement.clientHeight
        );
      } else {
        clientHeight = Math.max(
          document.body.clientHeight,
          document.documentElement.clientHeight
        );
      }
      return clientHeight;
    },

    // 获取文档完整的高度
    getScrollHeight() {
      return Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight
      );
    },
    // 滚动事件触发下拉加载
    onScroll() {
      if (this.GetCustomerDetail.total > this.Detail.length) {
        if (this.getScrollHeight() > this.getClientHeight()) {
          // 文档高度高于可视窗口高度
          if (
            this.getScrollHeight() -
              this.getClientHeight() -
              this.getScrollTop() <=
            500
          ) {
            if (!this.loading_data) {
              this.loading_data = true;
              this.$store
                .dispatch("CustomerInfo/GetCustomerDetail", this.parame)
                .then((res) => {
                  if (res.code == 1000) {
                    this.parame.page += 1;
                  } else {
                    Toast(res.message);
                  }
                  this.loading_data = false;
                });
            }
          }
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>